import React, { Fragment, useState } from "react";
import OptimizerComponent from "../../FormFields/OptimizerComponent/OptimizerComponent";
import FilterConfirmation from "../../FormFields/FilterConfirmationComponent/FilterConfirmation";
export default function MessageA61(props) {
  const { text_data, code } = props.item;
  const { tag, handleClick } = props;
  const [apllied, setApplied] = useState(false);
  const handleFilterApplied = (data) => {
    setApplied(data);
  };

  const onSubmitHandler = (code, data, tag) => {
    handleClick(code, data, tag);
  };
  return (
    <OptimizerComponent
      filterToggle={(data) => {
        handleFilterApplied(data);
      }}
      onClickSubmit={(code, data, tag) => {
        onSubmitHandler(code, data, tag);
      }}
      data={text_data}
      code={code}
      tag={tag}
    />
  );
}
